/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import { Badge, Button, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import objectPath from "object-path";
import React, { useEffect, useMemo, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { v4 } from "uuid";
import { DropdownTopbarItemToggler } from "../../../_metronic/_partials/dropdowns";
import { useHtmlClassService } from "../../../_metronic/layout";
import { WORK_FLOW_TYPE } from "../../../app/config/cacheKey";
import { cartableSet } from "../../../app/redux/activeCartable/activeCartableSlice";
import { ChatGetNotificationsResponse } from "../../models/chat.model";
import { seenNotification } from "../../redux/comments/commentSlice";
import { getJwtToken } from "../../services/auth.service";
import {
  ConfirmHasTheUserSeen,
  GetChatNotifications,
} from "../../services/chat.service";
import { isTokenExpired } from "../../utility/isTokenExpired";

export function SummaryComments(refreshQuickCartable: any) {
  const uiService = useHtmlClassService();

  const [notification, setNotification] = useState<
    ChatGetNotificationsResponse[]
  >([]);

  // const [cartableTotalCount, setCartableTotalCount] = useState(0);

  const dispatch = useDispatch();
  const history = useHistory<any>();
  const queryClient = useQueryClient();
  const activePage = localStorage.getItem("setActivePage");
  const userSeen = useSelector((state: any) => state.comment);
  const token = getJwtToken();

  const handleClick = (item: any) => {
    window.sessionStorage.setItem("natinalCode", item.person.nationalCode);
    dispatch(
      cartableSet({
        cartable: "LoanRegistrationBySupplier",
        refKey: item.referenceKey,
      })
    );
    dispatch(
      seenNotification({
        hasSeened: v4(),
      })
    );
    UserSeenMutation({ referenceKey: item.referenceKey });
    localStorage.setItem("setActivePage", "LoanRegistrationBySupplier");
    queryClient.setQueryData(WORK_FLOW_TYPE, item.cartableName);

    if (
      history.location.pathname ===
      `/loan/LoanRegistrationBySupplier1/loan-detail`
    ) {
      window.sessionStorage.setItem("id", item.referenceKey);
    } else {
      history.push({
        pathname: `/loan/LoanRegistrationBySupplier1/loan-detail`,
        state: {
          id: item.referenceKey,
          openChatDrawer: true,
        },
      });
    }
  };

  const { mutate: UserSeenMutation } = useMutation(ConfirmHasTheUserSeen, {
    onSuccess: (data: boolean) => {
      if (data) {
        getNotificationMutate();
      }
    },
    onError: () => {},
  });

  const handleMoreItems = () => {
    history.push({ pathname: "/Comments/History" });
  };

  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);

  const { mutate: getNotificationMutate } = useMutation(GetChatNotifications, {
    onSuccess: (data: ChatGetNotificationsResponse[]) => {
      setNotification(data);
    },
  });

  useEffect(() => {
    if (!isTokenExpired(token)) {
      getNotificationMutate();
    }
  }, []);

  const MINUTE_MS = 15 * 60 * 1000;

  useEffect(() => {
    if (!isTokenExpired(token)) {
      const interval = setInterval(() => {
        getNotificationMutate();
        //getCartables()
      }, MINUTE_MS);

      return () => clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    if (
      refreshQuickCartable != undefined &&
      refreshQuickCartable.refreshQuickCartable &&
      !isTokenExpired(token)
    ) {
      getNotificationMutate();
    }
  }, [refreshQuickCartable]);

  let totalNotifications = 0;
  if (notification) {
    for (let i = 0; i < notification!.length; i++) {
      totalNotifications += notification[i].totalCount;
    }
  }

  const jsonFile = useSelector((state: any) => state.style);

  return (
    <>
      {
        // notification.length > 0 &&
        <Tooltip title='گفتگو' placement='right'>
          <Dropdown drop='down' alignRight>
            <Dropdown.Toggle
              as={DropdownTopbarItemToggler}
              id='dropdown-toggle-user-profile'
            >
              <div
                className={
                  "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 divDrop1 marginLeft-10 "
                }
              >
                {true ? (
                  <>
                    <Badge
                      color={jsonFile?.badgeColor || "default"}
                      sx={{
                        "&.MuiBadge-badge": {
                          fontWeight: "bold",
                          fontSize: "14px !important",
                          direction: "ltr",
                        },
                      }}
                      badgeContent={
                        totalNotifications > 99
                          ? "+99"
                          : totalNotifications.toString()
                      }
                    >
                      <QuestionAnswerOutlinedIcon className='Icons BorderColor ' />
                    </Badge>
                  </>
                ) : (
                  <QuestionAnswerOutlinedIcon className='Icons BorderColor ' />
                )}
              </div>
            </Dropdown.Toggle>

            {notification !== null && notification.length > 0 && (
              <Dropdown.Menu
                className='p- m-0 dropdown-menu-right dropd
      own-menu-anim dropdown-menu-top-unround dropdown-menu-xl divDrop'
              >
                <>
                  {notification.length > 0 ? (
                    notification?.map((item: any, i: number) => (
                      <div className='navi navi-spacer-x-0 '>
                        {i === notification.length || i === 0 ? (
                          <></>
                        ) : (
                          <div className='navi-separator '></div>
                        )}

                        <Dropdown.Item className='itemDropMenuWallet'>
                          <div
                            className='navi-footer  px-2 py-5'
                            style={{ marginRight: "10px" }}
                          >
                            <Grid container alignItems={"center"}>
                              <Grid item>
                                <div className='chatCardOptions-noAvatar'>
                                  {item.person.genderType.toLowerCase() ===
                                  "male" ? (
                                    <img
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                      }}
                                      src='images/person_black_24dp.svg'
                                      alt='male user'
                                    />
                                  ) : (
                                    <img
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                      }}
                                      src='images/person_3_black_24dp.svg'
                                      alt='female user'
                                    />
                                  )}
                                </div>
                              </Grid>
                              <Grid item>
                                <div style={{ float: "right" }}>
                                  <Button
                                    style={{ color: "#fff", fontSize: "12px" }}
                                    className=' font-weight-bold colorFFF textFont11 '
                                    onClick={() => handleClick(item)}
                                  >
                                    تسهیلات {item.person.fullName}
                                  </Button>
                                </div>
                              </Grid>
                            </Grid>

                            <div style={{ float: "left" }}>
                              <Badge
                                sx={{
                                  "&.MuiBadge-badge": { fontWeight: "bold" },
                                }}
                                badgeContent={
                                  item.totalCount > 99 ? "+99" : item.totalCount
                                }
                                className='badgeStyle'
                              />
                            </div>
                          </div>

                          {notification.length > 5 && (
                            <div
                              style={{
                                paddingTop: "7px",
                                paddingBottom: "7px",
                              }}
                            >
                              <Grid
                                container
                                justifyContent={"center"}
                                alignItems={"center"}
                              >
                                <Grid
                                  item
                                  onClick={handleMoreItems}
                                  sx={{ cursor: "pointer" }}
                                >
                                  <Typography sx={{ color: "#fff" }}>
                                    بیشتر...
                                  </Typography>
                                </Grid>
                              </Grid>
                            </div>
                          )}
                        </Dropdown.Item>
                      </div>
                    ))
                  ) : (
                    <></>
                  )}
                </>
              </Dropdown.Menu>
            )}
          </Dropdown>
        </Tooltip>
      }
    </>
  );
}

const TOKEN_KEY = "token";
const handelToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.setItem("setActivePage", "Wellcome");
};
